import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Button, Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import DatePicker from "react-datepicker";

import { ThemeContext } from "../../../../context/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { AddInvoiceApi } from "../../../../service/bankApi/addInvoice";
import { toast, ToastContainer } from "react-toastify";
import { getInvoicesType } from "../../../../service/bankApi/getInvoiceTypes";
import Select from "react-select";
import VerificationTable from "../verificationScreen/verificationTable";
import { UpdateInvoiceApi } from "../../../../service/bankApi/updateInvoice";
import  "./verification.scss"
import { getPropertyListApi } from "../../../../service/property/propertyList";
import { getVendorByPropIdApi } from "../../../../service/property/getVendorByProp";
import { getInvoiceByIdApi } from "../../../../service/bankApi/getInvocieById";
import { setLoading } from "../../../../feature/authSlice";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";
import { VerificationEditTable } from "../verificationScreen/verificationEditTable";
import { approveInvoiceApi } from "../../../../service/bankApi/approveInvoice";
import { cancelInvoiceApi } from "../../../../service/bankApi/cancelInvoice";
import OtpModal from "../../OtpModal/OtpModal";
import { submitForApproval } from "../../../../service/bankApi/submitForApproval";
const ViewTelephoneInvoiceScreen = () => {
  const location = useLocation();
  const recievedData = location?.state;
  const paramId = recievedData?.Id
  const [permissionModal, setPermissionModal] = useState(false);
  const [modaleType, setModalType] = useState(null);
  const [isApiLaoding, setApiLoading] = useState(false);
  const [reason, setReason] = useState("")
  const [approveArrayData, setApproveArrayData] = useState([])
  const [approveInvoiceModal, setApproveInvoiceModal] = useState(false)
  const [otpModalStatus, setOtpModalStatus] = useState(false)
  const [otpValue, setOtpValue] = useState("")

  const dispatch = useDispatch();
  const {customerId} = useSelector(state => state.auth)
  const[propertiesList,setPropertiesList] = useState([])
  const[selectedPropertyId,setSelectedPropertyId] = useState({

  })
  const[selectedVendorId,setSelectedVendorId] = useState()
  const [vendorList,setVendorList] = useState([])
  const [selectVendorError,setSelectVendorError] = useState(false)
  const [value,setValue] = useState({})
  const [valuesObj, setValuesObj] = useState({})
  const [invoiceID, setInvoiceId] = useState()
  const [fileIDValue, setFileIdValue] = useState()
  const [tableArr, setTableArr] = useState([]);
  const [amount, setAmount] = useState();
  const [customerAddress, setCustomerAddress] = useState( );
  const [customerName, setCustomerName] = useState();
  const [invoiceDate, setInvoiceDate] = useState();
  const [circle,setCircle] = useState();

  const [invoiceDueDate, setInvoiceDueDate] = useState( );
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [leaseNumber, setLeaseNumber] = useState();
  const [RecieverGstin, setRecieverGstin] = useState();
  const [supplierAddress, setSupplierAddress] = useState();
  const [supplierGstin, setSupplierGstin] = useState();
  const [supplierName, setSupplierName] = useState();
  const [totalAmount, setTotalAmount] = useState();
  const [totalTaxValue, setTotalTaxValue] = useState();
  const [accountNumber,setAccountNumber]=useState()
  const [prevCharges,setPrevCharges]=useState()
  const [currentMonthUsageCharge,setCurrentMonthUsageCharge]=useState()
  const [currentMonthTotalPayableAmount,setCurrentMonthTotalPayableAmount]=useState()
  const [gstCharges,setGstCharges]=useState()
  const [totalPayableAmount,setTotalPayableAmount]=useState()
  const [isLoading, setIsLoading] = useState(false);
  const [fileId, setFileId] = useState();
  const [updatedArray, setUpdatedArray] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    value: "",
    label: "select property"
  });
  const { permissions } = useSelector((state) => state.permissionsData);
let PropertyId="";
const [canApproveFromApi,setCanApproveFromApi]=useState(false);
useEffect(()=>{
  if(recievedData?.tab==="Pending for Approval"){
   // console.log("recievedData",recievedData?.data?.Value?.CanApprove)
    setCanApproveFromApi(recievedData?.data?.Value?.CanApprove)
   }
    // console.log(paramId)
    var data ={
      // Id :parseInt(localStorage.getItem("invoiceId"))
      Id:paramId
    }
    dispatch(getInvoiceByIdApi(data,(res)=>{
      var obj = res.data.result.Value 
      // console.log(obj)
      setValue(res.data.result)
      setValuesObj(obj)
      setAccountNumber(obj.AccountNo)
      setPrevCharges(obj.PreviousCharges)
      setCurrentMonthTotalPayableAmount(obj.CurrentMonthTotalPayableCharges)
      setCurrentMonthUsageCharge(obj.CurrentMonthCharges)
      setGstCharges(obj.GSTCharges)
      setCircle(obj.Circle)
      setFileIdValue(obj.FileId)
      setTotalPayableAmount(obj.TotalAmount)
      setTableArr(res.data.result.TablesValues)
      setAmount(obj.Amount)
      setCustomerAddress(obj.CustomerAddress)
      setCustomerName(obj.CustomerName)
      setInvoiceDate(obj.InvoiceDate)
      setInvoiceDueDate(obj.InvoiceDueDate)
      setInvoiceNumber(obj.InvoiceNo)
      setLeaseNumber(obj.LeaseNo)
      setRecieverGstin(obj.ReceiverGstin)
      setSupplierAddress(obj.SupplierAddress)
      setSupplierGstin(obj.SupplierGstin)
      setSupplierName(obj.SupplierName)
      setTotalAmount(obj.TotalAmount)
      setTotalTaxValue(obj.TotalTaxValue)
      setFileId(obj.FileId)
      setSelectedOption({
        value: obj.InvoiceType,
        label: obj.InvoiceType
      })
      setSelectedVendorId(obj.VendorId)
      
  var data = {
    propertyId:obj.PropertyId || selectedPropertyId
  }

  dispatch(getVendorByPropIdApi(data,(res)=>{
    setVendorList(res.data.result)

  },(err)=>{console.log(err)}))

    },()=>{}))
  },[paramId,PropertyId])


 
  const notifyTopRight = () => {
    toast.success("✔️ Submit Successfully !!!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  useEffect(()=>{
    var data = {
      propertyId: selectedPropertyId
    }
  
    dispatch(getVendorByPropIdApi(data,(res)=>{
      setVendorList(res.data.result)
    },(err)=>{console.log(err)}))
  },[selectedPropertyId])



  function convertValue(e) {
    // Parse the string to a Date object
    const originalDate = new Date(e);

    // Extract the components of the date
    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, "0"); // months are zero-based
    const day = String(originalDate.getDate()).padStart(2, "0");
    const hours = String(originalDate.getHours()).padStart(2, "0");
    const minutes = String(originalDate.getMinutes()).padStart(2, "0");
    const seconds = String(originalDate.getSeconds()).padStart(2, "0");
    const milliseconds = String(originalDate.getMilliseconds()).padStart(
      7,
      "0"
    );

    // Get the timezone offset in minutes, then convert to hours and minutes
    const offsetInMinutes = originalDate.getTimezoneOffset();
    const offsetHours = String(
      Math.abs(Math.floor(offsetInMinutes / 60))
    ).padStart(2, "0");
    const offsetMinutes = String(Math.abs(offsetInMinutes % 60)).padStart(
      2,
      "0"
    );
    const offsetSign = offsetInMinutes <= 0 ? "+" : "-";
    const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

    // Format to desired ISO 8601-like string with milliseconds and timezone
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneOffset}`;
    return formattedDate;
  }

  function handleChangeInvoiceData(e) {
    const dataVal = convertValue(e);
    setInvoiceDate(dataVal);
  }


  useEffect(() => {
    var data = {

      Filter: "status==3",
      OrderBy: "AddressLine1",
      PageSize: 1000,
      PageNumber: 1

    }
    dispatch(getPropertyListApi(data, (res) => { 
      const matchedIndex = res.data?.result?.properties.findIndex(address => address.Id === PropertyId);
      
   
      setPropertiesList(res.data.result.properties)
    
      // console.log(res.data) 
    }, (err) => { console.log(err) }))
  }, [])
  useEffect(()=>{
    // matchId()
    // matchIdVendor()
   
  },[propertiesList])

// Helper function to check if a specific action exists in a submenu
const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);


  // Find the "Invoice" menu
  const invoiceMenu = findSubMenuByName(permissions, 'Invoice');
  const invoiceListMenu = invoiceMenu ? findSubMenuByName(invoiceMenu?.SubMenus, 'Invoice List') : null;
  const newSubMenu = invoiceListMenu ? findSubMenuByName(invoiceListMenu?.SubMenus, recievedData?.tab) : null;
  const editSubMenu = newSubMenu ? findSubMenuByName(newSubMenu?.SubMenus, 'Edit') : null;

  // Check if "Update" action exists in the "Edit" submenu
  const canUpdate = editSubMenu ? hasAction(editSubMenu, 'Update') : false;
  const canApprove = editSubMenu ? hasAction(editSubMenu, 'Approve') : false;
  const canReject = editSubMenu ? hasAction(editSubMenu, 'Reject') : false;
  const canSubmitForApproval = editSubMenu ? hasAction(editSubMenu, 'SubmitForApproval') : false;

  const datePickerRef = useRef(null);
  const datePickerDueRef = useRef(null);


  const openDatePicker = (ref) => {
    if (ref.current) {
      ref.current.setOpen(true);
    }
  };


  function handleMultipleApproveCalled() {
    setApiLoading(true)
    var data = [{
      InvoiceId: recievedData?.data?.Value?.Id,
      FileId: recievedData?.data?.Value?.FileId,
    }];
    var data = {
      ResendOtp: false,
      OTP: otpValue,
      approveList: data
    }

try {
  dispatch(
    approveInvoiceApi(
      data,
      (res) => {
        setApiLoading(false)
      
        if (res.data.result.ResponseMessage === "OTP sent successfully") {
          setOtpModalStatus(true)
          setPermissionModal(false);
          setApproveInvoiceModal(false);
          toast.success(res.data.result.ResponseMessage)
        
        } else {
          setOtpValue("")
          // window.history.go(-1)
          navigate("/invoiceList")
          setOtpModalStatus(false)
          setApproveInvoiceModal(false);
          navigate("/invoiceList")
          // window.history.go(-1)
          notifyTopRight();

        }



      },
      (err) => {
        setApiLoading(false)
      
      }
    )
  );
} catch (error) {

}
  }

  function handleApproveInvoiceOtp(element) {
    setOtpValue(element);
  }

  function handleResendOtp() {
    
    var data = {
      ResendOtp: true,
      OTP: "",
      approveList: approveArrayData
    }

  try {
    dispatch(
      approveInvoiceApi(
        data,
        (res) => {
toast.success(res.data.result.ResponseMessage)
        },
        (err) => {
        }
      )
    );
  } catch (error) {
  
  }
  }
  function handleCancelCalled() {
    
    setApiLoading(true)
    var data = {
      InvoiceId: recievedData?.data?.Value?.Id,
      FileId: recievedData?.data?.Value?.FileId,
      RejectionReason: reason
    };
if(reason!==''){
  try {
    dispatch(
      cancelInvoiceApi(
        data,
        (res) => {
          // onLoadData();
          navigate("/invoiceList")
          // window.history.go(-1)
          setApiLoading(false)
          setReason('')
          setPermissionModal(false);
          toast.success("Invoice rejected successfully")
          // console.log(res);
        
        },
        (err) => {
          setApiLoading(false)
        
          setReason('')
          // console.log(err);
        }
      )
    );
  } catch (error) {
  
    setReason('')
  }
  }
    else{
      toast.error('Please provide a reason')
    }
  
  }

  function handleInvoiceAcceptReject(action) {
    // console.log(data, action);
    if (action == "cancel") {
      setModalType(0);
      setPermissionModal(true);
      // setCancelInvoiceId(data.Id);
      // setCancelFileId(data.FileId);
    } else if (action == "approve") {
      setModalType(1);
      setPermissionModal(true);
      // setApproveInvoiceId(data.Id);
      // setApproveFileId(data.FileId);
    }
  }

  const navigate=useNavigate()

  const [submitForApproveInvoiceModal, setSubmitForApproveInvoiceModal] = useState(false)
  function handleActionMultipleSubmitForApprove(data) {
    setSubmitForApproveInvoiceModal(true)
  }

  function handleMultipleSubmitForApproveCalled() {
    setApiLoading(true)
    
    // const data = submitForApprovalArrayData.map((item) => item.InvoiceId);
    const data = [

recievedData?.data?.Value?.Id
  ];

try {
  dispatch(
    submitForApproval(
      data,
      (res) => {
        setApiLoading(false)
        if (res.data.message === "POST Request successful.") {
          setSubmitForApproveInvoiceModal(false);
          // window.history.go(-1)
          navigate("/invoiceList")
          toast.success("Submitted for approval successfully.")
        } else {
          setSubmitForApproveInvoiceModal(false);
          // onLoadData();
        }
      },
      (err) => {
        setApiLoading(false)
      }
    )
  );
} catch (error) {

}
  }

  return ( 
    <>
      <ToastContainer />
      {/* {  toaster && <AutohideToaster action={actionMessage} message={message} handleFucntion={()=>{setToaster(false)}}/>} */}
      <div className="row d-flex justify-content-between">
        {/* <BalanceCardSlider /> */}
        <div className="col-xl-6">
          <div className="card h-auto">
            <div
              className="card-body px-0 pt-1"
              style={{ maxHeight: "741px", overflowY: "auto" }}
            >
              <Tab.Container defaultActiveKey="Form">
                <div className="card-header border-0 pb-2 flex-wrap">
                <div className="d-flex">
                  <i className="material-icons" style={{cursor:'pointer',marginRight:'12px',marginTop:'1px'}} onClick={()=>window.history.go(-1)}>chevron_left</i> 
                  <h4 className="heading me-2"> Verification</h4>
                </div>
                  {/* <nav>
                    <Nav as="div" className="order nav nav-tabs" role="tablist">
                      <Nav.Link
                        as="button"
                        eventKey="Form"
                      // onClick={() => {
                      //   setOpenTab(1);
                      // }}
                      >
                        Form
                      </Nav.Link>
                    </Nav>
                  </nav> */}
                </div>
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="Form">
                      <Tab.Container>
                        <div className="sell-element">
                          <div className=" col-lg-12">
                          <div style={{
  position: "fixed",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: "10px",
  zIndex: 1000
}}>
                          {canSubmitForApproval && (
                             <button
                             disabled={canSubmitForApproval?false:true}
                      className="btn btn-primary"
                      style={{
                        background: "rgba(233, 133, 35, 1)",
                        border: "none",
                        marginLeft:'10px'
                      }}
                      onClick={() => handleActionMultipleSubmitForApprove()}
                    >
                      {isLoading ? "Submitting For Approval..." : "Submit For Approval"}
                    </button>
             )}
                      {canApprove && (
                              <button
                              disabled={canApproveFromApi?false:true}
                       className="btn btn-primary"
                       style={{
                         background: "rgba(233, 133, 35, 1)",
                         border: "none",
                         marginLeft:'10px'
                       }}
                       onClick={() => handleInvoiceAcceptReject("approve")}
                     >
                       {isLoading ? "Approving..." : "Approve"}
                     </button>
                      )}
                            {(recievedData?.tab === "New" || recievedData?.tab === "Pending for Approval") && (
                           <button
                           disabled={canReject ? false : true}
                           className="btn btn-primary"
                           style={{
                             background: "rgba(233, 133, 35, 1)",
                             border: "none",
                             marginLeft: '10px',
                           }}
                           onClick={() => handleInvoiceAcceptReject("cancel")}
                         >
                           {isLoading ? "Rejecting..." : "Reject"}
                         </button>
                            )}
</div>
                            <div className="card-body" style={{marginTop:'-25px'}}>
                              <div className="basic-form">
                                <form onSubmit={(e) => e.preventDefault()}>
                                <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                     Circle
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                      disabled
                                        className="form-control"
                                        value={circle}
                                        onChange={(e) => {
                                          setInvoiceNumber(e.target.value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                     Account Number
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                      disabled
                                        className="form-control"
                                        value={accountNumber}
                                        onChange={(e) => {
                                          setInvoiceNumber(e.target.value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice Number
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                      disabled
                                        className="form-control"
                                        value={invoiceNumber}
                                        onChange={(e) => {
                                          setInvoiceNumber(e.target.value);
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice date
                                    </label>
                                    <div className="col-sm-8">
                                      <DatePicker
                                       ref={datePickerRef}
                                       disabled
                                        className="form-control"
                                        value={invoiceDate?.split("T")[0]}
                                        onChange={(e) => {
                                          handleChangeInvoiceData(e);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-1" onClick={() => openDatePicker(datePickerRef)} >
                                      <i class="material-icons">
                                        calendar_month
                                      </i>
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Invoice due date
                                    </label>
                                    <div className="col-sm-8">
                                      <DatePicker
                                                                                        ref={datePickerDueRef}
                                       disabled
                                        className="form-control"
                                        value={invoiceDueDate?.split("T")[0]} 
                                      />
                                    </div>
                                    <div className="col-sm-1" onClick={() => openDatePicker(datePickerDueRef)}>
                                      <i class="material-icons">
                                        calendar_month
                                      </i>
                                    </div>
                                  </div>
                                  {/* 2 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Previous Charges
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                       disabled
                                        className="form-control"
                                        value={prevCharges}                        
                                      />                                    
                                    </div>
                                  </div>

                                  {/* 3 */}

                                  {/* 4 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Current Month Usage Charge
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                       disabled={canUpdate?false:true}
                                        className="form-txtarea form-control"
                                        rows="4"
                                        id="comment"
                                        value={currentMonthUsageCharge}
                                      ></input>
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      GST Charges
                                    </label>
                                    <div className="col-sm-9">
                                    <input
                                    disabled
                                        className="form-control"
                                        value={gstCharges}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Current Month Total Payable Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                       disabled
                                        className="form-control"
                                        value={currentMonthTotalPayableAmount}
                                      />                      
                                    </div>
                                  </div>
                                  {/* 5 */}
                                  <div className="mb-3 row">
                                    <label className="col-sm-3 col-form-label label-black">
                                      Total Payable Amount
                                    </label>
                                    <div className="col-sm-9">
                                      <input
                                       disabled
                                        className="form-control"
                                        value={totalPayableAmount}
                                      />                             
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Container>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
        <Modal className="fade" show={permissionModal} centered>
        <Modal.Header>
          <Modal.Title> {modaleType === 0 ? "Please provide reason :-" : "Alert"}</Modal.Title>
          <Button
            onClick={() => setPermissionModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
            {modaleType === 0 ? (
              <>
                <div className="ps-1 align-self-center">
                  <div className="custom-control custom-checkbox d-flex flex-column ">
                    <label
                      className="custom-control-label"
                      style={{ margin: "0px", color: 'black' }}
                    >

                      Reason
                    </label>
                    <textarea className="form-control" style={{ minHeight: '112px' }} value={reason} onChange={(e) => setReason(e.target.value)}>

                    </textarea>

                    &nbsp; &nbsp;

                  </div>
                </div>


              </>
            ) : (
              "Are you sure you want to approve this invoice?"
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setPermissionModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={modaleType == 0 ? handleCancelCalled : handleMultipleApproveCalled}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={approveInvoiceModal} centered>
        <Modal.Header>
          <Modal.Title> Approve Invoice</Modal.Title>
          <Button
            onClick={() => setApproveInvoiceModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">

            Are you sure you want to approve these invoices ?

          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setApproveInvoiceModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => { handleMultipleApproveCalled() }}
            disabled={isApiLaoding}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={submitForApproveInvoiceModal} centered>
        <Modal.Header>
          <Modal.Title> Submit For Approval</Modal.Title>
          <Button
            onClick={() => setSubmitForApproveInvoiceModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">

            Are you sure you want to submit these invoices for approval?

          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setSubmitForApproveInvoiceModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => { handleMultipleSubmitForApproveCalled() }}
            disabled={isApiLaoding}
          >
            {isApiLaoding ? "Proceeding" : "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

        <div className="col-xl-6">
          <div className="card h-auto">
            <div className="card-body px-0 pt-1" style={{ overflowY: "auto" }}>
              <Tab.Container defaultActiveKey="Navbuy">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="Navbuy"> 
      <iframe
                        src={value?.FilePath}
                        width="100%"
                        height={"700px"}
                      ></iframe>
                    </Tab.Pane>
                  </Tab.Content>
                  </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
      {
        otpModalStatus && <OtpModal
          otpModal={otpModalStatus}
          otp={otpValue}
          handleOtpChange={handleApproveInvoiceOtp}
          handleModalClose={() => {
            setOtpValue("")
            setOtpModalStatus(false)
          }}
          handleProceed={handleMultipleApproveCalled}
          resendOtp={handleResendOtp}
        />
      }
    </>
  );
};
export default ViewTelephoneInvoiceScreen;
